import { Ticket } from "lucide-react";
import type { ModuleSpec } from "../types";

export const ticketsSpec: ModuleSpec = {
  id: "tickets",
  icon: Ticket,
  i18n: {
    namespace: "modules",
    titleKey: "tickets.title",
    descriptionKey: "tickets.description",
  },
  nav: {
    path: "/tickets",
    group: "run",
    order: 25,
  },
  permission: {
    action: "read",
    subject: "conversation",
  },
  meta: {
    status: "active",
    description: "Manage support tickets",
  },
};
